import React, { useState, useDebugValue } from 'react'

export function CartContentContext(){
    const [display, setDisplay] = useState(null)
    return {display, setDisplay}
}

const CartContext = React.createContext(CartContentContext);
export default CartContext;